export default __webpack_public_path__ + "static/media/icon-wizard.670ade3a.svg";